export const TOTP_REGEX = /[0-9]/
export const STRING_CONTAIN_NUMBER_REGEX = /\d/
export const UPPER_CASE_REGEX = /[A-Z]/
export const LOWER_CASE_REGEX = /[a-z]/
export const SPECIAL_CHARACTER_REGEX = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/
